import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

export enum PhoneSearchInputVariants {
  Disabled = 'disabled',
  Ready = 'ready',
  Filled = 'filled',
}

const PhoneSearchInputParts = [
  'container',
  'input',
  'inputRightElement',
  'text',
] as const

const helpers = createMultiStyleConfigHelpers(PhoneSearchInputParts)
export const PhoneSearchInput = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      width: 'full',
      paddingBottom: '1rem',
      gap: '1.25rem',
    },
    input: {
      display: 'flex',
      flex: 1,
      color: 'fg.default',
      ...textStyles[textStyleKeys.H3],
      _placeholder: {
        color: 'fg.muted',
        ...textStyles[textStyleKeys.H3],
        textAlign: 'center',
      },
      //TODO this will overlap on the right with the clear btn
      paddingRight: 0,
    },
    inputRightElement: {
      height: 'full',
      marginRight: '0.75rem',
      opacity: 0,
      transition: 'opacity 0.15s ease-in-out',
      cursor: 'default',
      backgroundColor: 'transparent',
      _focusVisible: {
        opacity: '100%',
      },
    },
    text: {
      ...textStyles[textStyleKeys.Body2_Bold],
    },
  },
  variants: {
    [PhoneSearchInputVariants.Disabled]: {
      container: {
        borderColor: 'border.muted',
      },
      input: {
        _placeholder: {
          color: 'fg.muted',
          ...textStyles[textStyleKeys.H2],
        },
      },
    },
    [PhoneSearchInputVariants.Ready]: {},
    [PhoneSearchInputVariants.Filled]: {
      inputRightElement: {
        opacity: '100%',
        cursor: 'pointer',
      },
    },
  },
})

export const usePhoneSearchInputStyles = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(PhoneSearchInput, props) as MultiStyleType<
    typeof PhoneSearchInputParts
  >
}
